
export const extractProductIDfromObjectID = (objectID) => objectID.split(';').at(-1)
